/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ConditionPost } from './ConditionPost';
import type { DiscountPost } from './DiscountPost';
import type { PromotionTagAdditionalInfoPost } from './PromotionTagAdditionalInfoPost';
import type { PromotionTagPost } from './PromotionTagPost';
import type { RulePost } from './RulePost';

export type PromotionPost = {
  applicationType: PromotionPost.applicationType;
  description: string;
  checkLoyaltyBP: boolean;
  proposal?: boolean;
  shortDescription?: string;
  showData?: boolean;
  discounts: Array<DiscountPost>;
  rules: Array<RulePost>;
  conditions: Array<ConditionPost>;
  promotionTags?: Array<PromotionTagPost>;
  promotionTagAdditionalInfos?: Array<PromotionTagAdditionalInfoPost>;
  ptype: PromotionPost.ptype;
};

export namespace PromotionPost {

  export enum applicationType {
    DEFAULT = 'DEFAULT',
    BEST_CHOICE = 'BEST_CHOICE',
    CUMULATIVE = 'CUMULATIVE',
  }

  export enum ptype {
    TOTAL = 'TOTAL',
    BRACKETS = 'BRACKETS',
    CASHBACK = 'CASHBACK',
    PRICE_LIST = 'PRICE_LIST',
    OPERATOR_CHOICE = 'OPERATOR_CHOICE',
    LESS_PRICE = 'LESS_PRICE',
    HIGH_PRICE = 'HIGH_PRICE',
    ITEMS = 'ITEMS',
    POINTS = 'POINTS',
    GIFTS = 'GIFTS',
  }


}
